"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontSizes = [14, 16, 18, 20, 22, 26, 28, 34, 44].map(n => n + `px`);
exports.default = fontSizes;
//# sourceMappingURL=fontSizes.js.map